/**
 * ProgressBar — barre de progression avec libellé.
 */
import { h, setStyle } from "./dom.js";

export interface ProgressHandle {
	element: HTMLElement;
	setProgress(fraction: number, label?: string): void;
	reset(): void;
}

export function progressBar(options: { label?: string } = {}): ProgressHandle {
	const fill = h("div", { class: "progress-bar" });
	const text = h("span", { class: "progress-text" }, options.label ?? "");
	const element = h("div", { class: "progress-container" }, fill, text);

	function setProgress(fraction: number, label?: string): void {
		const pct = Math.max(0, Math.min(1, fraction)) * 100;
		setStyle(fill, "width", `${pct}%`);
		text.textContent = label ?? `${Math.round(pct)}%`;
	}

	function reset(): void {
		setStyle(fill, "width", "0%");
		text.textContent = options.label ?? "";
	}

	return { element, setProgress, reset };
}
